var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.7 61.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#66519d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DMS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.27,0h0a1.12,1.12,0,0,1,.32,0A1.12,1.12,0,0,0,50.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.4,2a2.82,2.82,0,0,0,0,.41,1.59,1.59,0,0,0,.09.33,1.59,1.59,0,0,1-.09-.33A2.82,2.82,0,0,1,49.4,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.28,3.27a.94.94,0,0,0,.34,0,.94.94,0,0,1-.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.5.52a1.13,1.13,0,0,0-.08.34,1.21,1.21,0,0,0,0,.19,1.21,1.21,0,0,1,0-.19A1.13,1.13,0,0,1,49.5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.14,2.08c0-.44,0-.88,0-1.32A1.14,1.14,0,0,0,51,.43a1.14,1.14,0,0,1,.08.33C51.15,1.2,51.15,1.64,51.14,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.41,1.62c0,.13,0,.27,0,.41a2.82,2.82,0,0,0,0,.41,1.59,1.59,0,0,0,.09.33.79.79,0,0,0,.42.44,1,1,0,0,0,.35.06.94.94,0,0,0,.34,0,1.1,1.1,0,0,0,.26-.15.88.88,0,0,0,.24-.57c0-.14,0-.29,0-.43,0-.44,0-.88,0-1.32A1.14,1.14,0,0,0,51,.43.79.79,0,0,0,50.59,0a1.12,1.12,0,0,0-.32,0,.89.89,0,0,0-.34.07.79.79,0,0,0-.43.45,1.13,1.13,0,0,0-.08.34,1.21,1.21,0,0,0,0,.19C49.4,1.24,49.41,1.43,49.41,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.29,44.74a.8.8,0,0,1,.18-.56.8.8,0,0,0-.18.56.88.88,0,0,0,.19.54A.88.88,0,0,1,5.29,44.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,45.55a.78.78,0,0,1-.54-.27A.78.78,0,0,0,6,45.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.48,45.28a.78.78,0,0,0,.54.27c.23,0,.46,0,.69,0h18a.84.84,0,0,0,.61-.25.86.86,0,0,0,.21-.6.78.78,0,0,0-.22-.57.92.92,0,0,0-.57-.26,3.38,3.38,0,0,0-.45,0h-18l-.25,0a.93.93,0,0,0-.52.3.8.8,0,0,0-.18.56A.88.88,0,0,0,5.48,45.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,21a1,1,0,0,0,0-.44A1,1,0,0,1,21,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.42,21.65a1,1,0,0,0,.36-.22A1,1,0,0,0,21,21a1,1,0,0,1-.19.4A1,1,0,0,1,20.42,21.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,20h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.77,21.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.73,20.79a1,1,0,0,1,.09-.35,1,1,0,0,0-.09.35.9.9,0,0,0,0,.37A.9.9,0,0,1,9.73,20.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.78,21.16a1,1,0,0,0,1,.57H20a1.33,1.33,0,0,0,.43-.07,1,1,0,0,0,.36-.22A1,1,0,0,0,21,21a1,1,0,0,0,0-.44c-.09-.48-.52-.63-1-.63H10.86a1.07,1.07,0,0,0-1,.48,1,1,0,0,0-.09.35A.9.9,0,0,0,9.78,21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.4,6.44a1.12,1.12,0,0,1,.27-.5,1.12,1.12,0,0,0-.27.5.81.81,0,0,0,.11.43A.81.81,0,0,1,58.4,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.51,6.87a.93.93,0,0,0,.71.46A.93.93,0,0,1,58.51,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.51,6.87a.93.93,0,0,0,.71.46.64.64,0,0,0,.42-.11,9,9,0,0,0,1.53-1.37.69.69,0,0,0,.11-.38.93.93,0,0,0-.09-.42.66.66,0,0,0-.12-.17,2.91,2.91,0,0,0-.31-.24l-.13-.08a.88.88,0,0,0-.29.06,3.36,3.36,0,0,0-.71.41,5,5,0,0,0-1,.91,1.12,1.12,0,0,0-.27.5A.81.81,0,0,0,58.51,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.78,4.1A.49.49,0,0,0,55.9,4a9.82,9.82,0,0,0,.75-1.65A9.82,9.82,0,0,1,55.9,4,.49.49,0,0,1,55.78,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.09,1.71a14.07,14.07,0,0,0-.66,1.49.83.83,0,0,0-.06.21.83.83,0,0,1,.06-.21A14.07,14.07,0,0,1,55.09,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.53,4a.65.65,0,0,1-.15-.35A.65.65,0,0,0,54.53,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.37,4.32h0A1,1,0,0,1,54.53,4,1,1,0,0,0,55.37,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.53,4a1,1,0,0,0,.84.35l.26-.12a.78.78,0,0,0,.15-.1A.49.49,0,0,0,55.9,4a9.82,9.82,0,0,0,.75-1.65.77.77,0,0,0-.46-1,.8.8,0,0,0-1.1.43,14.07,14.07,0,0,0-.66,1.49.83.83,0,0,0-.06.21,1.48,1.48,0,0,0,0,.21A.65.65,0,0,0,54.53,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.07,10.53a1,1,0,0,0-.08.52c0,.28.45.49.7.73.38-.13.74-.23,1.08-.34a5.52,5.52,0,0,0,.93-.39,1.14,1.14,0,0,0,.36-.94A.51.51,0,0,0,64,9.83a.69.69,0,0,0-.76-.28,7.3,7.3,0,0,0-1.84.58A.82.82,0,0,0,61.07,10.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.73,51.13V52.6l1.39-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.46,49.24a.68.68,0,0,1,.11.46c0,.72,0,1.44,0,2.15s0,1.52,0,2.28a.52.52,0,0,1,0,.22.52.52,0,0,0,0-.22c0-.76,0-1.52,0-2.28s0-1.43,0-2.15A.68.68,0,0,0,21.46,49.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.8,54.62h0a.88.88,0,0,1-.24,0A.88.88,0,0,0,17.8,54.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,49.09h0c-1.05,0-2.1,0-3.16,0a.9.9,0,0,0-.25,0,.9.9,0,0,1,.25,0C18.9,49.11,20,49.11,21,49.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.1,27.79a2.11,2.11,0,0,0,0-.35A2.11,2.11,0,0,1,25.1,27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.1,27.79a.89.89,0,0,1-.08.33A.89.89,0,0,0,25.1,27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.9,27a.25.25,0,0,0-.16.16A.25.25,0,0,1,5.9,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.26,26.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.08,27.44a1.1,1.1,0,0,0,0-.18A.43.43,0,0,0,25,27a.43.43,0,0,1,.11.28A1.1,1.1,0,0,1,25.08,27.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.71,27.28a3,3,0,0,0,0,.47v0A3,3,0,0,1,5.71,27.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.85,16.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.24,15h0a11.27,11.27,0,0,1,1.75.15A11.27,11.27,0,0,0,62.24,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.61,16.39a1,1,0,0,0,.08-.31.89.89,0,0,0,0-.33.89.89,0,0,1,0,.33A1,1,0,0,1,64.61,16.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,15.17A11.27,11.27,0,0,0,62.24,15a.77.77,0,0,0-.58.2.82.82,0,0,0-.16.25,1,1,0,0,0,0,.66.79.79,0,0,0,.69.55c.41.08.83.11,1.19.16h.5a1.16,1.16,0,0,0,.34-.05.69.69,0,0,0,.42-.4,1,1,0,0,0,.08-.31.89.89,0,0,0,0-.33A.8.8,0,0,0,64,15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.9,19.77a.77.77,0,0,1,.3,0A.77.77,0,0,0,39.9,19.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.2,19.8a.76.76,0,0,1,.45.43,1,1,0,0,1,.09.31,1,1,0,0,0-.09-.31A.76.76,0,0,0,40.2,19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.34,21.34c-.29.18-.58.35-.89.52.31-.17.6-.34.89-.52a.79.79,0,0,0,.39-.5A.79.79,0,0,1,40.34,21.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.2,19.8a.77.77,0,0,0-.3,0,.76.76,0,0,0-.32.08,9.33,9.33,0,0,0-.83.43,7,7,0,0,0-.77.53.43.43,0,0,0-.12.17,1.14,1.14,0,0,0-.08.72c.08.26.41.44.69.72l1-.56c.31-.17.6-.34.89-.52a.79.79,0,0,0,.39-.5,1,1,0,0,0-.08-.61A.76.76,0,0,0,40.2,19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.61,8.85a.65.65,0,0,0,.44-.31,1.36,1.36,0,0,0,.13-.47,1.36,1.36,0,0,1-.13.47A.65.65,0,0,1,56.61,8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.86,21.69a2.71,2.71,0,0,0-.78-.71A2.71,2.71,0,0,1,46.86,21.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.17,9.15a7.24,7.24,0,0,1,1.52-1.34A7.24,7.24,0,0,0,44.17,9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.15,23.24A.56.56,0,0,1,47,22.7a1.52,1.52,0,0,0,0-.56,1.52,1.52,0,0,1,0,.56A.56.56,0,0,0,47.15,23.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,18.79a1.17,1.17,0,0,1-.3-.29,1.17,1.17,0,0,0,.3.29,1.61,1.61,0,0,1,.81,1.12A1.61,1.61,0,0,0,48.58,18.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.88,6.26A9.53,9.53,0,0,0,42,9.32,9.53,9.53,0,0,1,44.88,6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.8,31.84c.15,0,.29,0,.44,0h0C50.09,31.84,50,31.83,49.8,31.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.56,18.53a8.82,8.82,0,0,1-.67-1.91A8.82,8.82,0,0,0,41.56,18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.42,20.45a2.38,2.38,0,0,0,0-.54A2.38,2.38,0,0,1,49.42,20.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.28,19.44a1,1,0,0,0-.1.47A1,1,0,0,1,51.28,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.41,12.32a3,3,0,0,0-1.45.32,3,3,0,0,1,1.45-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.3,23.26a.52.52,0,0,0,.43.11A.52.52,0,0,1,51.3,23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.33,4.61a9.22,9.22,0,0,1,2.24.26A9.22,9.22,0,0,0,50.33,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.56,18.23A2.54,2.54,0,0,0,52.87,17c0-.38,0-.76,0-1.14,0,.38,0,.76,0,1.14A2.54,2.54,0,0,1,52.56,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.19,23.17c.16-.16.2-.43.21-.92C49.39,22.74,49.35,23,49.19,23.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.17,9.15a7.47,7.47,0,0,0-1.44,2.72A7.47,7.47,0,0,1,44.17,9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.52,33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.44,26c0,.32,0,.65,0,1,0,.67,0,1.35,0,2,0-.67,0-1.35,0-2C44.46,26.61,44.45,26.28,44.44,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,14.55a8.22,8.22,0,0,0-.38-2.9,1.36,1.36,0,0,0-.13-.3,1.36,1.36,0,0,1,.13.3A8.22,8.22,0,0,1,60,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.93,11.68a1.77,1.77,0,0,1,.16-.22,1.77,1.77,0,0,0-.16.22c-.09.14,0,.4.06.62C57.93,12.08,57.84,11.82,57.93,11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.2,10.9A9.94,9.94,0,0,1,42,9.32,9.94,9.94,0,0,0,41.2,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49,33.53a1.77,1.77,0,0,1-.91-.26A1.77,1.77,0,0,0,49,33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.16,23.5a1.11,1.11,0,0,0,.16-.38A1.11,1.11,0,0,1,45.16,23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.3,22.77a.71.71,0,0,0-.22-.32A.71.71,0,0,1,45.3,22.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.81,7.14,56.65,7a10.73,10.73,0,0,0-3-1.81,10.73,10.73,0,0,1,3,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,9.32a9.67,9.67,0,0,0-1.25,6.27c0,.35.11.7.19,1a8.82,8.82,0,0,0,.67,1.91,9.74,9.74,0,0,0,3.33,3.77,1,1,0,0,1,.19.15.71.71,0,0,1,.22.32.59.59,0,0,1,0,.35,1.11,1.11,0,0,1-.16.38l-.15.2A2.68,2.68,0,0,0,44.49,25a6.37,6.37,0,0,0-.05,1c0,.32,0,.65,0,1,0,.67,0,1.35,0,2a1.38,1.38,0,0,0,.84,1.45,2.41,2.41,0,0,0,.65.13c.34,0,.6,0,.79.06a.78.78,0,0,1,.41.17c.18.18.19.51.22,1.17a1.82,1.82,0,0,0,.14.64,1.32,1.32,0,0,0,.33.5,1.45,1.45,0,0,0,.23.19,1.77,1.77,0,0,0,.91.26h2.53a1.57,1.57,0,0,0,1.55-1,1.84,1.84,0,0,0,.15-.69c.09-1.29.09-1.29,1.34-1.35a1.47,1.47,0,0,0,1.58-1.64c0-1.28,0-2.57,0-3.86a1.33,1.33,0,0,0,0-.4,1.5,1.5,0,0,0-.29-.7,1.83,1.83,0,0,0-.27-.3.84.84,0,0,1-.32-.67.73.73,0,0,1,.12-.34,1.19,1.19,0,0,1,.3-.29A11.43,11.43,0,0,0,57.27,21,9.61,9.61,0,0,0,59,18.51a9.38,9.38,0,0,0,.68-1.93c.08-.34.15-.69.2-1.06s.07-.64.08-1a8.22,8.22,0,0,0-.38-2.9,1.36,1.36,0,0,0-.13-.3.62.62,0,0,0-.73-.35,1.4,1.4,0,0,0-.64.46,1.77,1.77,0,0,0-.16.22c-.09.14,0,.4.06.62,0,0,0,.07,0,.1a7.94,7.94,0,0,1-.86,5.9,7.32,7.32,0,0,1-.69,1,7.76,7.76,0,0,1-1.84,1.62l-.27.18a3.19,3.19,0,0,0-.43.37,1.76,1.76,0,0,0-.29.44,1.53,1.53,0,0,0-.1.54,1.93,1.93,0,0,0,0,.33c.07.41-.11.63-.57.6a10.59,10.59,0,0,0-1.26,0,.52.52,0,0,1-.43-.11.28.28,0,0,1-.09-.18,1,1,0,0,1,0-.26c0-1,0-1.94,0-2.91a1,1,0,0,1,.1-.47.9.9,0,0,1,.36-.33,2.69,2.69,0,0,0,.53-.39,2.25,2.25,0,0,0,.7-1.74c0-.38,0-.76,0-1.14s0-.76,0-1.14a2.38,2.38,0,0,0-1.08-2,2.73,2.73,0,0,0-1.37-.42,3,3,0,0,0-1.45.32,2.3,2.3,0,0,0-1.22,1.89,11.73,11.73,0,0,0,0,2.65,3.21,3.21,0,0,0,.52,1.32,1.17,1.17,0,0,0,.3.29,1.61,1.61,0,0,1,.81,1.12,2.38,2.38,0,0,1,0,.54,2.81,2.81,0,0,1,0,.29c0,.32,0,.64,0,1s0,.4,0,.56c0,.49,0,.76-.21.92s-.63.2-1.47.21a.89.89,0,0,1-.57-.14A.56.56,0,0,1,47,22.7a1.52,1.52,0,0,0,0-.56,1.63,1.63,0,0,0-.18-.45,2.71,2.71,0,0,0-.78-.71,7.58,7.58,0,0,1-3.6-8c.07-.38.15-.74.25-1.09a7.47,7.47,0,0,1,1.44-2.72,7.24,7.24,0,0,1,1.52-1.34,7.64,7.64,0,0,1,.92-.54,9.46,9.46,0,0,1,1-.43,9,9,0,0,1,1.06-.31,7.5,7.5,0,0,1,2-.19,8.05,8.05,0,0,1,4.71,1.92,6.51,6.51,0,0,0,.6.47.86.86,0,0,0,.57.12.65.65,0,0,0,.44-.31,1.36,1.36,0,0,0,.13-.47,2.15,2.15,0,0,0,0-.51.93.93,0,0,0-.34-.42L56.65,7a10.73,10.73,0,0,0-3-1.81,10.16,10.16,0,0,0-1.07-.33,9.22,9.22,0,0,0-2.24-.26,10.81,10.81,0,0,0-2.35.3c-.28.07-.55.15-.82.24s-.53.19-.79.3a10.2,10.2,0,0,0-1.49.81A9.53,9.53,0,0,0,42,9.32Zm8.73,22.52h-.44c-.15,0-.29,0-.44,0-.44,0-.72-.06-.72-.6s.18-.73.7-.7.8,0,1.2,0,.44.16.47.5C51.5,31.65,51.31,31.93,50.68,31.84Zm-1.24-17a.76.76,0,0,1,.85-.8.79.79,0,0,1,.87.8,9.37,9.37,0,0,1,0,1.06h0a9.53,9.53,0,0,1,0,1.07.81.81,0,0,1-.89.79.8.8,0,0,1-.84-.84C49.42,16.23,49.42,15.53,49.44,14.84ZM46.16,25.66c0-.45.18-.6.6-.6q3.54,0,7.08,0c.41,0,.58.17.58.57,0,.88,0,1.77,0,2.65,0,.41-.17.55-.58.54-1.2,0-2.4,0-3.6,0s-2.28,0-3.41,0c-.49,0-.69-.13-.68-.64C46.18,27.34,46.17,26.5,46.16,25.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.83,28.82c1.13,0,2.27,0,3.41,0s2.4,0,3.6,0c-1.2,0-2.4,0-3.6,0S48,28.79,46.83,28.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.83,20.84a.77.77,0,0,0,.33.43c.26.18.52.35.79.51-.27-.16-.53-.33-.79-.51A.77.77,0,0,1,59.83,20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.84,21.56a1,1,0,0,1-.18.4A1,1,0,0,0,62.84,21.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.36,22.21a.76.76,0,0,1-.37.06A.76.76,0,0,0,62.36,22.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.56,19.77a.52.52,0,0,1,.27.05A.52.52,0,0,0,60.56,19.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.67,20.86a12.79,12.79,0,0,0-1.84-1,.52.52,0,0,0-.27-.05.8.8,0,0,0-.65.5.85.85,0,0,0-.08.57.77.77,0,0,0,.33.43c.26.18.52.35.79.51a8.29,8.29,0,0,0,.84.43.65.65,0,0,0,.57,0,.65.65,0,0,0,.3-.25,1,1,0,0,0,.18-.4,1,1,0,0,0,0-.25.94.94,0,0,1,0-.09A.53.53,0,0,0,62.67,20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.9,1.22h0l.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,1.29a1.35,1.35,0,0,1,.31.2A1.35,1.35,0,0,0,45,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.26,3.11c-.11-.26-.24-.51-.34-.78a.73.73,0,0,1,0-.41.73.73,0,0,0,0,.41C44,2.6,44.15,2.85,44.26,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.92,2.33c.1.27.23.52.34.78s.22.52.35.77a.75.75,0,0,0,.76.45,1,1,0,0,0,.32-.07.77.77,0,0,0,.46-.4.82.82,0,0,0,0-.62,10,10,0,0,0-.72-1.6.44.44,0,0,0-.12-.15,1.35,1.35,0,0,0-.31-.2l-.11-.07a1,1,0,0,0-1,.52.64.64,0,0,0-.06.18A.73.73,0,0,0,43.92,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,4.49a2.76,2.76,0,0,1,.57.24A2.76,2.76,0,0,0,40,4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.84,7.17a.85.85,0,0,0,.28.15.85.85,0,0,1-.28-.15A8.71,8.71,0,0,1,39.49,6,1.11,1.11,0,0,1,39.4,5a1.11,1.11,0,0,0,.09.91A8.71,8.71,0,0,0,40.84,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.49,6a8.71,8.71,0,0,0,1.35,1.22.85.85,0,0,0,.28.15.67.67,0,0,0,.55-.07.91.91,0,0,0,.24-.2.87.87,0,0,0,.24-.58.79.79,0,0,0-.23-.57,14.58,14.58,0,0,0-1.31-1.17A2.76,2.76,0,0,0,40,4.49c-.2.16-.55.31-.64.55A1.11,1.11,0,0,0,39.49,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,12.4s0-.06,0-.1a.3.3,0,0,0,0,.1,7.94,7.94,0,0,1-.86,5.9A7.94,7.94,0,0,0,58,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.46,19.29a7.76,7.76,0,0,1-1.84,1.62l-.27.18.27-.18A7.76,7.76,0,0,0,56.46,19.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.31,30.41a2.41,2.41,0,0,0,.65.13c.34,0,.6,0,.79.06-.19,0-.45,0-.79-.06A2.41,2.41,0,0,1,45.31,30.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.52,33.53h0a1.57,1.57,0,0,0,1.55-1A1.57,1.57,0,0,1,51.52,33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.16,30.77a.78.78,0,0,0-.41-.17A.78.78,0,0,1,47.16,30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.82,23.94a1.83,1.83,0,0,0-.27-.3.84.84,0,0,1-.32-.67.84.84,0,0,0,.32.67A1.83,1.83,0,0,1,55.82,23.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.14,28.9c0-1.28,0-2.57,0-3.86a1.33,1.33,0,0,0,0-.4,1.33,1.33,0,0,1,0,.4C56.13,26.33,56.14,27.62,56.14,28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.35,22.63a1.19,1.19,0,0,1,.3-.29A11.43,11.43,0,0,0,57.27,21a11.43,11.43,0,0,1-1.62,1.36A1.19,1.19,0,0,0,55.35,22.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.56,30.54a1.47,1.47,0,0,0,1.58-1.64A1.47,1.47,0,0,1,54.56,30.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,8.73a6.51,6.51,0,0,1-.6-.47A6.51,6.51,0,0,0,56,8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.73,6.34a7.5,7.5,0,0,0-2,.19A7.5,7.5,0,0,1,50.73,6.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.41,12.32h0a2.73,2.73,0,0,1,1.37.42A2.73,2.73,0,0,0,50.41,12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.53,22.44a1.53,1.53,0,0,1,.1-.54A1.53,1.53,0,0,0,53.53,22.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.88,6.26a10.2,10.2,0,0,1,1.49-.81A10.2,10.2,0,0,0,44.88,6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.63,21.9a1.76,1.76,0,0,1,.29-.44A1.76,1.76,0,0,0,53.63,21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.69,16.58A9.38,9.38,0,0,1,59,18.51,9.38,9.38,0,0,0,59.69,16.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.52,32.58a1.82,1.82,0,0,1-.14-.64A1.82,1.82,0,0,0,47.52,32.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.85,33.08a1.32,1.32,0,0,1-.33-.5A1.32,1.32,0,0,0,47.85,33.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.21,23.08a1,1,0,0,1,0-.26c0-1,0-1.94,0-2.91,0,1,0,1.94,0,2.91A1,1,0,0,0,51.21,23.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,18.51A9.61,9.61,0,0,1,57.27,21,9.61,9.61,0,0,0,59,18.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.28,19.44a.9.9,0,0,1,.36-.33,2.69,2.69,0,0,0,.53-.39,2.69,2.69,0,0,1-.53.39A.9.9,0,0,0,51.28,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.61,7.27a9.46,9.46,0,0,1,1-.43,9,9,0,0,1,1.06-.31,9,9,0,0,0-1.06.31A9.46,9.46,0,0,0,46.61,7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.74,14.53a11.73,11.73,0,0,0,0,2.65,3.21,3.21,0,0,0,.52,1.32,3.21,3.21,0,0,1-.52-1.32A11.73,11.73,0,0,1,47.74,14.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.33,4.61a10.81,10.81,0,0,0-2.35.3c-.28.07-.55.15-.82.24.27-.09.54-.17.82-.24A10.81,10.81,0,0,1,50.33,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.24,43.86l-.25,0a.93.93,0,0,0-.52.3.93.93,0,0,1,.52-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.7,43.88a.92.92,0,0,1,.57.26A.92.92,0,0,0,24.7,43.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,45.55c.23,0,.46,0,.69,0h0C6.48,45.57,6.25,45.57,6,45.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.28,45.31a.86.86,0,0,0,.21-.6.78.78,0,0,0-.22-.57.78.78,0,0,1,.22.57A.86.86,0,0,1,25.28,45.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,45.57h1.65a.84.84,0,0,0,.61-.25.84.84,0,0,1-.61.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.86,20h0a1.07,1.07,0,0,0-1,.48A1.07,1.07,0,0,1,10.86,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.78,21.16a1,1,0,0,0,1,.57h0A1,1,0,0,1,9.78,21.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.38,21.73H20a1.33,1.33,0,0,0,.43-.07,1.33,1.33,0,0,1-.43.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.41,1.62c0-.19,0-.38,0-.57,0,.19,0,.38,0,.57s0,.27,0,.41C49.4,1.89,49.41,1.75,49.41,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.88,3.08a.88.88,0,0,0,.24-.57c0-.14,0-.29,0-.43,0,.14,0,.29,0,.43A.88.88,0,0,1,50.88,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.27,0a.89.89,0,0,0-.34.07A.89.89,0,0,1,50.27,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.28,3.27h0a1,1,0,0,1-.35-.06A1,1,0,0,0,50.28,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.28,5.47a.69.69,0,0,1-.11.38A.69.69,0,0,0,61.28,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.64,7.22a.64.64,0,0,1-.42.11.64.64,0,0,0,.42-.11,9,9,0,0,0,1.53-1.37A9,9,0,0,1,59.64,7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.63,5a3.36,3.36,0,0,1,.71-.41A3.36,3.36,0,0,0,59.63,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.76,4.64a2.91,2.91,0,0,1,.31.24A2.91,2.91,0,0,0,60.76,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.67,7.25a.91.91,0,0,0,.24-.2.87.87,0,0,0,.24-.58.87.87,0,0,1-.24.58A.91.91,0,0,1,41.67,7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61,11.05a1,1,0,0,1,.08-.52A1,1,0,0,0,61,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.7,11.05a5.52,5.52,0,0,1-.93.39,5.52,5.52,0,0,0,.93-.39,1.14,1.14,0,0,0,.36-.94A.51.51,0,0,0,64,9.83a.51.51,0,0,1,.08.28A1.14,1.14,0,0,1,63.7,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.67,15.75a.8.8,0,0,0-.68-.58A.8.8,0,0,1,64.67,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.24,15a.77.77,0,0,0-.58.2.77.77,0,0,1,.58-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.5,15.47a1,1,0,0,0,0,.66,1,1,0,0,1,0-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.85,16.84a1.16,1.16,0,0,0,.34-.05,1.16,1.16,0,0,1-.34.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.75,20.28a7,7,0,0,0-.77.53.43.43,0,0,0-.12.17.43.43,0,0,1,.12-.17A7,7,0,0,1,38.75,20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.58,19.85a.76.76,0,0,1,.32-.08A.76.76,0,0,0,39.58,19.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.9,1.22h0a1,1,0,0,0-1,.52A1,1,0,0,1,44.9,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.15,3.86a.82.82,0,0,0,0-.62A.82.82,0,0,1,46.15,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.61,3.88c-.13-.25-.23-.52-.35-.77.12.25.22.52.35.77a.75.75,0,0,0,.76.45A.75.75,0,0,1,44.61,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.84,21.22a.53.53,0,0,0-.17-.36,12.79,12.79,0,0,0-1.84-1,12.79,12.79,0,0,1,1.84,1A.53.53,0,0,1,62.84,21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.91,20.27a.8.8,0,0,1,.65-.5.8.8,0,0,0-.65.5.85.85,0,0,0-.08.57A.85.85,0,0,1,59.91,20.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.37,4.32l.26-.12-.26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.81,61.88H29a1.53,1.53,0,0,0,1.69-1.68c0-1,0-2,0-3s0-.9.9-.9H47a5.81,5.81,0,0,0,2.84-.71l4.39-2.39a1.54,1.54,0,0,0,1-1.35,1.51,1.51,0,0,0-1-1.35c-1.37-.75-2.75-1.48-4.1-2.25a6.28,6.28,0,0,0-3.38-.87c-.54,0-1.09,0-1.64,0H31.56c-.86,0-.86,0-.86-.87,0-.57,0-1.14,0-1.71s.13-.62.61-.63A16.8,16.8,0,0,0,33.76,44,15.61,15.61,0,0,0,45,36.63a1.82,1.82,0,0,0,0-2.17A15.61,15.61,0,0,0,31.55,26.9c-.85,0-.85,0-.85-.88V15.46c0-1.4-.56-2-1.95-2H12.24c-.23,0-.53,0-.67.08a1.75,1.75,0,0,0-.61.83c-.1.42.21.71.64.79a4.21,4.21,0,0,0,.87.08H28.29c.4,0,.7,0,.7.54,0,3.59,0,7.17,0,10.76,0,.18-.11.48-.23.52-.61.19-1.24.3-1.9.45a4,4,0,0,1-.05-.47c-.06-1.47-.55-1.94-2-1.94H5.84A1.63,1.63,0,0,0,4,27V39.52c0,1.29.56,1.85,1.84,1.85q8,0,16.07,0a2.3,2.3,0,0,1,1.11.32A16.14,16.14,0,0,0,28.4,43.9a.61.61,0,0,1,.59.72c0,.63,0,1.26,0,1.9,0,.88,0,.88-.87.88H17.62a2.27,2.27,0,0,0-1.55.59,1.7,1.7,0,0,1-.93.38c-1.49,0-3,0-4.49,0H6.22a.83.83,0,0,0-.93.82c0,.49.36.85.94.89h.51c2.72,0,5.44,0,8.16,0,.52,0,.73.16.7.68a7.69,7.69,0,0,0,0,1.27c.05.61-.14.84-.81.83-2.74,0-5.48,0-8.22,0a2.16,2.16,0,0,0-.57,0,.82.82,0,0,0-.71.9.77.77,0,0,0,.78.77c.25,0,.51,0,.76,0,2.68,0,5.36,0,8,0,.25,0,.66.13.72.3a2.13,2.13,0,0,0,2.32,1.45c3.44,0,6.88,0,10.31,0,.58,0,.81.17.78.75,0,.78,0,1.56,0,2.34,0,.61-.21.79-.81.79q-12.78,0-25.56,0c-.59,0-.8-.14-.8-.77q0-21.69,0-43.4c0-.22,0-.45,0-.73H6.6a3.94,3.94,0,0,0,.69,0,.8.8,0,0,0,.76-.92.86.86,0,0,0-1-.8c-1.57,0-3.13,0-4.69,0A2.08,2.08,0,0,0,0,14.84V60.53A1.8,1.8,0,0,0,1.81,61.88ZM51.73,51.13l1.39.74-1.39.73ZM47.8,49.08c.72.35,1.32.62,1.9.94a.41.41,0,0,1,.14.17.57.57,0,0,1,.06.24c0,1,0,1.9,0,2.84a.74.74,0,0,1,0,.25.37.37,0,0,1-.13.18c-.58.32-1.18.6-1.92,1ZM19.86,39.66l-.35,0h-13c-.52,0-.72,0-.8-.22a1.4,1.4,0,0,1,0-.36V27.75a3,3,0,0,1,0-.47.33.33,0,0,1,0-.15A.25.25,0,0,1,5.9,27a1.11,1.11,0,0,1,.36,0H24.37c.2,0,.44-.08.58.05a.43.43,0,0,1,.11.28,1.1,1.1,0,0,1,0,.18,2.11,2.11,0,0,1,0,.35.89.89,0,0,1-.08.33.83.83,0,0,1-.25.29l-.2.12a14.49,14.49,0,0,0-2,1.13,15,15,0,0,0-2.53,2.16,16.65,16.65,0,0,0-2,2.68,2,2,0,0,0-.35,1.07,1.7,1.7,0,0,0,.37,1c.58.8,1.18,1.59,1.77,2.38l.21.27c.09.1.18.22.29.36Zm-.13-3.6a.8.8,0,0,1,0-1,13.63,13.63,0,0,1,10.42-6.32c5.57-.5,9.9,1.72,13.1,6.24a.9.9,0,0,1,0,1.18,13.94,13.94,0,0,1-10,6.22c-.58.07-1.17.11-1.72.16A14.16,14.16,0,0,1,19.73,36.06Zm1.83,15.79c0,.76,0,1.52,0,2.28a.52.52,0,0,1,0,.22c-.05.19-.19.27-.45.27H17.8a.88.88,0,0,1-.24,0,.29.29,0,0,1-.16-.1.58.58,0,0,1-.11-.4c0-1.48,0-3,0-4.43,0-.3.08-.47.3-.53a.9.9,0,0,1,.25,0c1.06,0,2.11,0,3.16,0h0a.81.81,0,0,1,.29,0,.34.34,0,0,1,.17.11.68.68,0,0,1,.11.46C21.55,50.42,21.56,51.14,21.56,51.85Zm2.62,2.76c-.29,0-.79-.09-.82-.21a5.39,5.39,0,0,1,0-1.5c0-.07.4-.14.62-.14h13.1c.24,0,.57,0,.73-.1a1.39,1.39,0,0,0,.56-.84c0-.26-.34-.58-.61-.75A1.61,1.61,0,0,0,37,51H24.06c-.78,0-.78,0-.79-.89s0-1,.78-1c7,0,14.08,0,21.13,0,.62,0,.9.15.82.81A7.49,7.49,0,0,0,46,51h-3.1a5.58,5.58,0,0,0-.82,0c-.51.07-.89.29-.89.87a.88.88,0,0,0,1,.89c1,0,2.07,0,3.1,0,.61,0,.85.16.76.77a2.66,2.66,0,0,0,0,.63c0,.36-.15.5-.49.48H24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.54,26.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.37,26.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.32,39.62l-.46,0,.46,0c-.11-.14-.2-.26-.29-.36C20.12,39.36,20.21,39.48,20.32,39.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.61,29.66a14.49,14.49,0,0,1,2-1.13l.2-.12-.2.12A13.9,13.9,0,0,0,22.61,29.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.54,39.68h13l.35,0-.35,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.68,35.57A2,2,0,0,1,18,34.5a16.65,16.65,0,0,1,2-2.68,16.65,16.65,0,0,0-2,2.68A2,2,0,0,0,17.68,35.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.61,29.66a15,15,0,0,0-2.53,2.16A15,15,0,0,1,22.61,29.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.74,39.46a1.4,1.4,0,0,1,0-.36A1.4,1.4,0,0,0,5.74,39.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.82,39l.21.27L19.82,39c-.59-.79-1.19-1.58-1.77-2.38a1.7,1.7,0,0,1-.37-1,1.7,1.7,0,0,0,.37,1C18.63,37.41,19.23,38.2,19.82,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,49.09h0a.81.81,0,0,1,.29,0A.81.81,0,0,0,21,49.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.8,54.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.29,49.66c0,1.48,0,3,0,4.43a.58.58,0,0,0,.11.4.58.58,0,0,1-.11-.4C17.3,52.61,17.3,51.14,17.29,49.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.9,53.27a.74.74,0,0,1,0,.25.74.74,0,0,0,0-.25c0-.94,0-1.89,0-2.84a.57.57,0,0,0-.06-.24.57.57,0,0,1,.06.24C49.92,51.38,49.92,52.33,49.9,53.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.72,53.7a.37.37,0,0,0,.13-.18A.37.37,0,0,1,49.72,53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.73,51.13l1.39.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.71,16.84h.52c.34,0,.76-.08,1.17-.15a.81.81,0,0,0,.76-.86.77.77,0,0,0-.85-.81,6.76,6.76,0,0,0-1.75.18,1.2,1.2,0,0,0-.65.86C35.85,16.5,36.2,16.82,36.71,16.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.91,11.1c.57.24,1.17.41,1.76.62.48,0,.88-.21.92-.65a1.11,1.11,0,0,0-.37-.93,7.68,7.68,0,0,0-1.83-.59.71.71,0,0,0-.88.53A.77.77,0,0,0,36.91,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,35.57a5.53,5.53,0,1,0-11,0,5.53,5.53,0,1,0,11.05,0Zm-5.26,3.75a3.78,3.78,0,0,1-4-2.83,3.52,3.52,0,0,1,1.46-3.87,5.7,5.7,0,0,0,5.47,4.62C34.6,38.27,33.2,39.25,31.78,39.32Zm3-3.84A3.84,3.84,0,0,1,31,32.19c-.07-.39,0-.45.68-.44a3.82,3.82,0,0,1,3.58,3.17C35.33,35.35,35.18,35.48,34.82,35.48Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage5);
export default __webpack_public_path__ + "static/media/Image5.8b6cd67940e91c8e9bfa372b57bc6d6f.svg";
export { ForwardRef as ReactComponent };